import { type ReactNode } from "react";

import HeaderSkeleton from "./HeaderSkeleton";
import MenuSkeleton from "./MenuSkeleton";

export default function LayoutSkeleton({ children }: { children: ReactNode }) {
  return (
    <div className="flex h-screen flex-col overflow-y-auto">
      <div className="flex h-full flex-1 items-start">
        <MenuSkeleton />
        <div className="relative flex h-full flex-1 flex-col gap-2 overflow-y-auto">
          <HeaderSkeleton />
          <div className="h-full flex-1 bg-white p-6">{children}</div>
        </div>
      </div>
    </div>
  );
}
